module.exports = __webpack_public_path__ + "img/insta-8.0add5374.jpg";